import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalizefirst',
    standalone: false
})
export class CapitalizefirstPipe implements PipeTransform {
  transform(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}